export default __webpack_public_path__ + "static/media/facebook-circle.eccfb62a.svg";